var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import PlayerEventBus from "@/EventBuses/ThePlayerEventBus";
var ThePlayerProgressBar = (function (_super) {
    __extends(ThePlayerProgressBar, _super);
    function ThePlayerProgressBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buffer = 0;
        _this.bufferValue = 0;
        _this.tooltipTime = "";
        _this.player = _this.$store.state.player;
        return _this;
    }
    ThePlayerProgressBar.prototype.onClick = function (e) {
        var target = e.target.parentElement.parentElement;
        var totalWidth = target.offsetWidth;
        var clickedWidth = e.offsetX;
        var percentageClicked = (clickedWidth / totalWidth);
        PlayerEventBus.$emit("seekTo", percentageClicked * this.player.duration);
    };
    ThePlayerProgressBar.prototype.formatTime = function (time) {
        time = Math.round(time);
        var minutes = Math.floor(time / 60), seconds = time - minutes * 60, sSeconds = seconds < 10 ? "0" + seconds : seconds;
        return minutes + ":" + sSeconds;
    };
    ThePlayerProgressBar.prototype.showTime = function (e) {
        if (!this.$store.getters.audio) {
            return;
        }
        var target = e.target.parentElement.parentElement, totalWidth = target.offsetWidth, clickedWidth = e.offsetX, percentageHovered = (clickedWidth / totalWidth) * 100;
        this.tooltipTime = this.formatTime((percentageHovered / 100) * this.player.duration);
        this.$refs.time["style"].display = "block";
        var tooltipWidth = 60;
        if (e.offsetX > tooltipWidth / 2 && e.offsetX < totalWidth - tooltipWidth / 2) {
            this.$refs.time["style"].left = e.offsetX - tooltipWidth / 2 + "px";
        }
        else if (e.offsetX <= tooltipWidth / 2) {
            this.$refs.time["style"].left = 0;
        }
        else if (e.offsetX > totalWidth - tooltipWidth / 2) {
            this.$refs.time["style"].left = totalWidth - tooltipWidth + "px";
        }
    };
    ThePlayerProgressBar.prototype.hideTime = function (e) {
        this.$refs.time["style"].display = "none";
    };
    ThePlayerProgressBar.prototype.onTimeChange = function (newTime, oldTime) {
        this.buffer = (newTime / this.player.duration) * 100;
    };
    ThePlayerProgressBar.prototype.onBufferedChange = function (newVal) {
        this.bufferValue = 100 * (newVal / this.player.duration);
    };
    __decorate([
        Watch("player.time"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], ThePlayerProgressBar.prototype, "onTimeChange", null);
    __decorate([
        Watch("player.buffered"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ThePlayerProgressBar.prototype, "onBufferedChange", null);
    ThePlayerProgressBar = __decorate([
        Component
    ], ThePlayerProgressBar);
    return ThePlayerProgressBar;
}(Vue));
export default ThePlayerProgressBar;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/ThePlayer/ThePlayerProgressBar.vue
// module id = 272
// module chunks = 0